module.exports = __webpack_public_path__ + "img/map-cluster-3.85704317.svg";